import React from 'react';
import TextInput from '../inputs/TextInput';
import { FormContext, TableContext } from './context';
import { mapValidation, changeRequirement, inputIsActive } from '@defi/core-utils';

var DataElement = function DataElement(props) {
  switch (props.children.get('DataElement').get('DataType')) {
    case 'Boolean':
      return null;

    case 'Dropdown':
      return null;

    default:
      if (props.children.get('DataElement').get('DataType') === 'GTLTDropdown' && props.children.getIn(['DataElement', 'Name']) !== 'Year') {
        return null;
      }

      return React.createElement(FormContext.Consumer, null, function (_ref) {
        var editStatus = _ref.editStatus,
            coApplicantIsActive = _ref.coApplicantIsActive,
            conditionalRequirements = _ref.conditionalRequirements,
            setConditionalRequirement = _ref.setConditionalRequirement,
            employmentDurationInYears = _ref.employmentDurationInYears,
            residencyDurationInYears = _ref.residencyDurationInYears,
            toggleSnackbar = _ref.toggleSnackbar;
        return React.createElement(TableContext.Consumer, null, function (_ref2) {
          var toggle = _ref2.toggle,
              open = _ref2.open;
          return React.createElement(TextInput, {
            editStatus: editStatus,
            validation: mapValidation(props.children, coApplicantIsActive, conditionalRequirements),
            toggleSection: toggle,
            changeRequirement: changeRequirement(props.children.get('DataElement'), setConditionalRequirement),
            employmentDurationInYears: employmentDurationInYears,
            residencyDurationInYears: residencyDurationInYears,
            toggleSnackbar: toggleSnackbar,
            open: open,
            disabled: Boolean(props.children.get('IsReadOnly')) || !editStatus || !inputIsActive(props.children, coApplicantIsActive)
          }, props.children);
        });
      });
  }
};

export default DataElement;